(() => {
  'use strict';

  const CART_ICON_SELECTOR = '#cart-icon-bubble';

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return false;

    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    // Fallback: try to focus the drawer container
    const inner = drawer.querySelector('#CartDrawer, .cart-drawer, .drawer__inner');
    if (inner && typeof inner.focus === 'function') {
      inner.focus();
      return true;
    }

    return false;
  }

  // Open when clicking the cart icon
  document.addEventListener('click', (e) => {
    const link = e.target && e.target.closest ? e.target.closest(CART_ICON_SELECTOR) : null;
    if (!link) return;

    const opened = openDrawer();
    if (opened) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // Open after successful add-to-cart (fetch)
  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = async function (...args) {
      const res = await originalFetch.apply(this, args);
      try {
        const url = args && args[0] ? String(args[0]) : '';
        if (res && res.ok && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
          setTimeout(() => {
            openDrawer();
          }, 50);
        }
      } catch (_) {}
      return res;
    };
  }

  // Open after successful add-to-cart (XHR)
  const XHROpen = XMLHttpRequest.prototype.open;
  const XHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__ji_url = url;
    return XHROpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('loadend', () => {
      try {
        const url = String(this.__ji_url || '');
        if (this.status >= 200 && this.status < 300 && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
          setTimeout(() => {
            openDrawer();
          }, 50);
        }
      } catch (_) {}
    });
    return XHRSend.apply(this, args);
  };
})();
